
import MainThreeColumns from "@/layouts/MainThreeColumns.vue";
import RouteMixin from "@/mixins/route";
import { defineComponent } from "vue";

export default defineComponent({
  name: "no-route",
  props: ["errors"],
  mixins: [RouteMixin],
  components: {
    MainThreeColumns,
  },
});
